import { createFileRoute } from '@tanstack/react-router';
import { MockExamReviewPage } from '@/features/mockExams/admin/ExamReviewQueue';
export const Route = createFileRoute('/_authed/teacher/mock-exams')({
  component: MockExamReviewPage,
});
